/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isKeyframesTarget as t}from"../animation/utils/is-keyframes-target.js";const o=t=>Boolean(t&&"object"==typeof t&&t.mix&&t.toValue),e=o=>t(o)?o[o.length-1]||0:o;export{o as isCustomValue,e as resolveFinalValueInKeyframes};
//# sourceMappingURL=resolve-value.js.map
